module.exports = __webpack_public_path__ + "img/Picture3.07bb3148.png";